var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2375 4899 c-782 -64 -1478 -510 -1864 -1196 -324 -576 -385 -1281 -167 -1912 116 -333 289 -611 540 -869 705 -723 1792 -913 2701 -472 491 239 898 659 1115 1150 358 809 242 1724 -306 2422 -129 164 -385 396 -564 510 -199 127 -446 236 -665 293 -166 44 -277 62 -445 75 -150 11 -199 11 -345 -1z m490 -443 c202 -36 347 -83 524 -167 740 -354 1173 -1138 1076 -1949 -79 -665 -485 -1230 -1090 -1516 -522 -246 -1120 -244 -1644 7 -399 191 -709 502 -900 900 -85 177 -129 318 -168 529 -24 133 -24 467 0 600 39 211 83 352 168 529 286 598 847 997 1519 1080 107 14 408 6 515 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1732 3519 c-19 -6 -53 -30 -77 -53 -67 -67 -82 -151 -44 -236 15 -33 103 -128 332 -357 l311 -313 -315 -317 c-350 -352 -358 -362 -346 -465 16 -136 156 -221 284 -173 40 15 100 69 366 334 l317 315 318 -315 c265 -265 325 -319 365 -334 128 -48 268 37 284 173 12 103 4 113 -346 465 l-315 317 311 313 c171 171 319 328 329 347 23 44 24 143 1 186 -24 46 -91 102 -139 114 -48 13 -105 7 -152 -16 -17 -9 -172 -156 -343 -327 l-313 -312 -312 312 c-230 229 -325 317 -358 332 -48 22 -104 25 -158 10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.30ed29b3581267a75098f10e41c1679b.svg";
export { ForwardRef as ReactComponent };